export default __webpack_public_path__ + "static/media/3.2fb37c5f.jpg";